<template>
    <Card class="provider-extern-mailing-conf">
        <CompassDialog
            :visible.sync="showModal"
            size="small"
            :title="$t.__('preferences.ProviderExternMailingConf.change_campaign_sending_service')"
            @closed="closePopup"
        >
            <template #default>
                <div class="dialog__default">
                    <el-radio-group v-model="providerSelected" class="flex-column">
                        <el-radio
                            v-for="(provider, key) in providers"
                            :key="provider.id"
                            class="flex-row ai-center"
                            :label="provider.id"
                            :class="key !== providers.length - 1 ? 'mb-4' : ''"
                        >
                            <template #default>
                                <span class="flex-row ai-center">
                                    <SaasIcon :width="40" :height="40" :icon="provider.icon" />
                                    <span class="semibold fs-3 ml-2 gray-100 lh-20">
                                        {{ provider.name }}
                                    </span>
                                    <tag-rounded
                                        v-if="provider.id === 1 || provider.id === 4"
                                        :label="$t.__('common.labels.by_default')"
                                        color="gray-60 "
                                        class="ml-2 semibold py-1"
                                        :radius="44"
                                        bgcolor="secondary-grey"
                                    >
                                    </tag-rounded>
                                </span>
                            </template>
                        </el-radio>
                    </el-radio-group>
                </div>
            </template>
            <template #footer>
                <div class="dialog__footer">
                    <CompassButton
                        :label="$t.__('common.actions.cancel')"
                        type="secondary"
                        @click="closePopup"
                    />
                    <CompassButton
                        :label="$t.__('common.actions.continue')"
                        type="primary"
                        class="ml-3"
                        @click="onProviderChanged"
                    />
                </div>
            </template>
        </CompassDialog>

        <div class="service-campaign-container">
            <div class="service-campaign-subcontainer">
                <SaasIcon v-if="provider.icon" :width="40" :height="40" :icon="provider.icon" />
                <span class="bold fs-4 ml-2">{{ provider.name }}</span>
                <div class="ml-2" v-if="provider.id === 1 || provider.id === 4">
                    <tag-rounded
                        :label="$t.__('common.labels.by_default')"
                        color="gray-60 "
                        class="semibold py-1 default-tag"
                        :radius="44"
                        bgcolor="secondary-grey"
                    >
                    </tag-rounded>
                </div>
            </div>
            <CompassButton
                :label="$t.__('common.actions.edit')"
                type="primary"
                class="ml-5"
                @click="onModifProvider"
            />
        </div>
    </Card>
</template>

<script>
import Card from 'vcomponents/common/card/Card.vue';
import TagRounded from 'vcomponents/utilities/TagRounded.vue';

import { createNamespacedHelpers } from 'vuex';
import SaasIcon from 'vcomponents/common/SaasIcon.vue';

const popupPanelMapActions = createNamespacedHelpers('popupPanel').mapActions;

const icons = {
    1: 'sellsyCloud',
    2: 'mailjet',
    3: 'mailChimp',
    4: 'sellsyCloud',
};

export default {
    name: 'ProviderExternMailingConf',
    components: {
        SaasIcon,
        TagRounded,
        Card,
    },
    data() {
        return {
            showModal: false,
            providersIds: {
                sellsy: 1,
                mailjet: 2,
                mailchimp: 3,
                sendethic: 4,
            },
            providers: [],
            provider: {},
            providerSelected: 0,
        };
    },
    created() {
        ApiClient.get('/settings/marketing/providers', {})
            .then((response) => {
                this.initProvider(response.data);
            })
            .catch((error) => {
                Push.error(error.message);
            });
        EventBus.on('onUpdateProviderFromPopup', this.updateProvider);
    },
    beforeDestroy() {
        EventBus.off('onUpdateProviderFromPopup', this.updateProvider);
    },
    methods: {
        ...popupPanelMapActions(['open']),
        initProvider(data) {
            this.providers = data.available_providers;
            this.providers.forEach((provider) => {
                provider.icon = icons[provider.id];
            });
            this.provider = this.providers.find((provider) => provider.id === data.provider.id);
            this.providerSelected = this.provider.id;
        },
        onModifProvider() {
            this.showModal = true;
        },
        onProviderChanged() {
            this.closePopup();
            switch (this.providerSelected) {
                default:
                    this.updateProvider(this.providersIds.sellsy);
                    break;

                case this.providersIds.sellsy:
                case this.providersIds.sendethic:
                    this.updateProvider(this.providerSelected);
                    break;

                case this.providersIds.mailjet:
                    this.open({
                        key: 'popupMailjetSettings',
                        props: {
                            mode: 'marketing',
                            callback: 'onUpdateProviderFromPopup',
                        },
                    });
                    break;
                case this.providersIds.mailchimp:
                    this.providerSelected = this.provider.id;
                    this.open({
                        key: 'popupMailchimpSettings',
                        props: {
                            mode: 'marketing',
                            callback: 'onUpdateProviderFromPopup',
                        },
                    });
                    break;
            }
        },
        closePopup() {
            this.showModal = false;
            setTimeout(() => (this.providerSelected = this.provider.id), 500);
        },
        updateProvider(providerId) {
            ApiClient.put('/settings/marketing/providers', {}, { provider_id: providerId })
                .then((response) => {
                    this.initProvider(response.data);
                    Push.success(this.$l10n.__("Service d'envoi de campagne mis à jour."));
                })
                .catch((error) => {
                    Push.error('Une erreur est survenue');
                    throw error;
                });
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';

.provider-extern-mailing-conf {
    .service-campaign {
        &-container {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        &-subcontainer {
            display: flex;
            align-items: center;
        }
    }
    .dialog {
        &__default {
            padding-bottom: 24px;
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 32px 24px 32px;
        }
    }

    .flex-row.ai-center {
        div .default-tag {
            border: none !important;
        }
    }
}
</style>
